@if (showAnalysisConfig) {
  <app-polly-manage-analysis-config [launchSource]="launchSource"
    [isSelectedWorkspace]="isWorkspaceSelected" [currentWorkspace]="currentWorkspace"
    [workspaceSelectorConfig]="analysisConfigPayload" [showLoader]="showLoader"
    (setConfig)="onAnalysisConfigSubmit($event)" (gtmEvent)="gtmEvent.emit($event)" [filterStatus]="filterStatus"
    (createWorkspace)="createWorkspace.emit($event)" (closeComponent)="closeComponent.emit(false)" [datasetInfo]="dataset"
    [currentRepository]="repository" [repoID]="repoID" [applicationTitle]="applicationTitle" [currentRepoV2]="currentRepoV2">
  </app-polly-manage-analysis-config>
}

@if (deprecatedAppName) {
  <app-polly-manage-deprecated-app [appName]="deprecatedAppName"
    (closeComponent)="closeComponent.emit(false)">
  </app-polly-manage-deprecated-app>
}